<template>
  <el-dialog custom-class="lease-renew-form-dialog lease-dialog" :visible="show" @open="handleOpen" @update:visible="(flag) => this.$emit('update:show', flag)" title="续租">
    <el-form label-position="top">
      <el-form-item label="订单类型">
        <el-select v-model="form.RentalOrderType" placeholder="订单类型">
          <el-option label="固定租期" value="inflexibleTerm"></el-option>
          <el-option label="灵活租期" value="flexibleTerm"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table :data="list">
      <el-table-column label="批次号" width="170px">
        <template scope="props">{{props.row.LotCode}}</template>
      </el-table-column>
      <el-table-column label="物料名称/编码" width="260px">
        <template scope="props">
          <p class="no-margin">{{props.row.ProductName}}</p>
          <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="物料品项" width="170px">
        <template scope="props">
          <el-tag :type="props.row.ConditionName | ConditionColor">{{props.row.ConditionName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="租赁周期" width="170px">
        <template scope="props">{{props.row.RentalPeriod}}个月</template>
      </el-table-column>
      <el-table-column label="折扣" width="170px">
        <template scope="props">{{props.row.DiscountRate * 100}}%</template>
      </el-table-column>
      <el-table-column label="原租金" width="170px">
        <template scope="props">{{props.row.RentalAmount | amount}}</template>
      </el-table-column>
      <el-table-column label="已租天数" width="170px">
        <template scope="props">{{Math.round(props.row.RentDays)}}天</template>
      </el-table-column>
      <el-table-column label="保修" width="200px">
        <template scope="props">
          <el-select v-model="Products[props.$index].WarrantyDays">
            <el-option v-for="WarrantyOption in WarrantyOptions[props.$index]"
            :key="WarrantyOption.PeriodInDays" :value="WarrantyOption.PeriodInDays" :label="`￥${WarrantyOption.UnitPriceAmount}/${WarrantyOption.PeriodInDays}天`"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="续租时间" width="160px">
        <template scope="props">
          <el-select v-model="Products[props.$index].RentalPeriodInDays">
            <el-option :value="90" label="3个月"></el-option>
            <el-option :value="180" label="6个月"></el-option>
            <el-option :value="360" label="12个月"></el-option>
            <el-option :value="540" label="18个月"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="续租单价" width="140px">
        <template scope="props">{{props.row.RentalAmount | amount}}</template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <span class="count">续租数量：{{this.list.length}}个</span>
      <el-button type="primary" @click="handleConfirm()">提交并等待客服联系</el-button>
    </span>
  </el-dialog>
</template>

<script>
import o from '@/odata'
export default {
  data() {
    return {
      form: {
        RentalOrderType: 'flexibleTerm',
      },
      Products: [],
      WarrantyOptions: [],
    }
  },
  computed: {
    // LineIds() {
    //   return this.list.map(item => item.LineId)
    // },
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleConfirm() {
      let form = this.form
      form.Lines = this.Products
      this.$emit('confirm', 'Renewal', form)
    },
    handleOpen() {
      this.Products = this.list.map(item => {
        return {
          ProductLotLineId: item.LineId,
          RentalPeriodInDays: null,
          WarrantyDays: null,
        }
      })
      this.list.forEach((item, index) => {
        const { ConditionId, ProductId } = item
        o(`AfterSalesRequest/Services.GetWarrantyUnitPrices(productId=${ProductId},conditionId=${ConditionId})`).get((data) => {
          this.WarrantyOptions[index] = data
        })
      })
    },
  },
}
</script>

<style lang="less">
.lease-dialog.lease-renew-form-dialog {
  width: 1310px;
}
</style>



// WEBPACK FOOTER //
// RenewFormDialog.vue?1da1ff15